<template>
  <div v-if="cartorioId"
       id="dashboardSofiaRei"
       class="content busca">
    <div class="content--body">
      <div class="appSearch">
        <SearchFilters :order-by="orderBy"
                       @SearchParams="searchParamsUpdates"
                       @onSearch="search"
                       @onPage="updatePage"
                       @onClear="clearSearch" />
      </div>

      <ResultOptions v-if="result !== null"
                     :updated="result"
                     :exclude-all="(cardsSelected.length > 19 || cardsSelected.length > (items.length - 1))"
                     :last-page="lastPage"
                     :list-for-exclude="cardsSelected"
                     :order-by="orderBy"
                     :page="page"
                     :rascunho="searchParams.flag_somente_rascunhos"
                     @onNextPage="nextPage"
                     @onPreviousPage="previousPage"
                     @onSetPage="(page) => setPage(page)"
                     @onUpdateOrder="(order) => {orderBy = order}"
                     @onSelectAll="selectAllCards"
                     @onExcludeAll="excludeAll"
                     @onUpdateSearch="updateSearch" />

      <div v-if="result !== null"
           class="py-1 py-sm-3">
        <SearchCard v-for="item in items"
                    :key="item.registro_id"
                    :rascunho="searchParams.flag_somente_rascunhos"
                    class="mb-3"
                    :check="item.check"
                    :data-info="item"
                    @onExcludeAll="excludeAll"
                    @onUpdateSearch="updateSearch"
                    @onSelectCard="selectCard" />
      </div>

      <Pagination v-if="items.length > 0"
                  :page="page"
                  :last-page="lastPage"
                  @onPreviousPage="previousPage"
                  @onNextPage="nextPage" />

      <AddButton @OnShowModal="showModal" />

      <!-- modal para acesso ao nascimento -->
      <b-modal id="modal-nascimento"
               ref="modal-nascimento"
               centered
               size="md"
               hide-footer
               title="Adicionar nascimento:">
        <div class="row">
          <div class="col-6">
            <b-link class="btn btn-outline-primary btn-block"
                    :to="{ name: 'cadastro_nascimento', params: { idNasc: 'novo' }}">
              Novo registro
            </b-link>
          </div>

          <div class="col-6 text-right">
            <b-link class="btn btn-outline-primary btn-block"
                    :to="{ name: 'cadastro_nascimento_legado', params: { idNasc: 'novo' }}">
              2ª via
            </b-link>
          </div>
        </div>
      </b-modal>

      <!-- modal para acesso ao casamento -->
      <b-modal id="modal-casamento"
               ref="modal-casamento"
               centered
               size="lg"
               hide-footer
               title="Adicionar casamento">
        <div class="row">
          <div class="col-4">
            <b-link class="btn btn-outline-primary btn-block"
                    :to="{ name: 'habilitar_casamento', params: { id: 'novo' }}">
              Habilitação de Casamento
            </b-link>
          </div>

          <div class="col-4 text-center">
            <b-link class="btn btn-outline-primary btn-block"
                    :to="{ name: 'registro_casamento', params: { id: 'novo' }}">
              Novo registro
            </b-link>
          </div>

          <div class="col-4 text-right">
            <b-link class="btn btn-outline-primary btn-block"
                    :to="{ name: 'registro_casamento_legado', params: { id: 'novo' }}">
              2ª via
            </b-link>
          </div>
        </div>
      </b-modal>

      <!-- modal para acesso a óbito -->
      <b-modal id="modal-obito"
               ref="modal-obito"
               centered
               size="md"
               hide-footer
               title="Registrar óbito:">
        <div class="row">
          <div class="col-6">
            <b-link class="btn btn-outline-primary btn-block"
                    :to="{ name: 'cadastro_obito' }">
              Novo registro
            </b-link>
          </div>

          <div class="col-6 text-right">
            <b-link class="btn btn-outline-primary btn-block"
                    :to="{ name: 'cadastro_obito_legado' }">
              2ª via
            </b-link>
          </div>
        </div>
      </b-modal>



      <!-- modal para acesso ao casamento -->
      <b-modal id="modal-pre-registro"
               ref="modal-pre-registro"
               no-close-on-backdrop
               no-close-on-esc
               centered
               hide-footer
               size="md"
               title="Importar Pré-Registro">
        <pre-registro @onCloseModal="$refs['modal-pre-registro'].hide()" />
      </b-modal>
    </div>
  </div>
</template>

<script>
  // components
  import SearchCard from "@/components/SofiaRei/Busca/SearchCard"
  import SearchFilters from "@/components/SofiaRei/Busca/SearchFilters"
  import ResultOptions from "@/components/SofiaRei/Busca/ResultOptions"
  import addIcon from '@/assets/icons/add.svg?sprite'
  import AddButton from "@/components/SofiaRei/AddButton"
  import PreRegistro from "@/components/PreRegistro"
  import Pagination from "@/components/SofiaRei/Pagination.vue"

  /* services */
  import BuscaService from '@/services/BuscaService'

  /* helpers */
  import { order, compType } from '@/helpers/orders'
  import { transformSearchedRascunho } from '@/utils/itemRascunho'
  import { mapGetters } from "vuex"

  export default {
    name: "Dashboard",
    components: {
      SearchCard,
      SearchFilters,
      ResultOptions,
      AddButton,
      PreRegistro,
      Pagination
    },
    data () {
      return {
        result: null,
        items: [],
        orderBy: '',
        lastPage: 0,
        params: {},
        cardsSelected: [],
        addIcon,
        searchParams: {}
      }
    },
    computed: {
      ...mapGetters({
        cartorioId: 'auth/getCartorioId'
      })
    },
    mounted () {
      NProgress.done()


    },
    
    methods: {
      getRegisterNameProp (tipo = 'default') {
        let registerNameProp = {
          'N': 'nascimento.nome_registrado',
          'C': 'casamento.nome_registrado_1',
          'O': 'obito.nome_registrado',
          'default': 'nome'
        }

        if (tipo instanceof Array) {
          for (const key of Object.keys(registerNameProp)) {
            if (tipo.includes(key)) {
              tipo = key
              break
            }
          }
        }

        return (registerNameProp[tipo] || registerNameProp['default'])
      },
      searchParamsUpdates (params) {
        this.searchParams = params
      },
      search (result) {
        this.cardsSelected = []
        this.clearSearch()
        this.result = result || { total: 0, perPage: 0, page: 0, lastPage: 0,  data: []}

        this.items = result.data || []
        this.items.map(item => item.tipo_registro === this.searchParams.tipo_livro)

        this.page = result.page
        this.lastPage = result.lastPage

        if (!result.total) {
          this.result = null
          objSwal.info.title = ""
          objSwal.info.text = "Nenhum resultado encontrado"
          return Swal.fire(objSwal.info)
        }

        // TODO: Remover, a ordenação está sendo feita no back-end
        // if (this.orderBy) {
        //   this.updateOrder(this.orderBy)
        // }

      },
      updatePage (pag) {
        this.page = pag
      },
      updateOrder (str) {
        this.orderBy = str

        // TODO: Remover, a ordenação está sendo feita no back-end
        // if (str === null)
        //   return (this.items = order(this.result.data, 'registro_id'))
        // if (str !== "nome")
        //   return (this.items = order(this.result.data, str))

        // const { tipo_livro, flag_somente_rascunhos } = this.searchParams

        // return (this.items = order(
        //   this.result.data,
        //   (item) => {
        //     let nameProp = this.getRegisterNameProp(flag_somente_rascunhos ? 'RASCUNHO' : tipo_livro).split('.')

        //     if (nameProp.length === 1) {
        //       return item[nameProp[0]].toUpperCase()
        //     } else if (nameProp.length === 2) {
        //       return item[nameProp[0]][nameProp[1]].toUpperCase()
        //     }
        //   }
        // ))

      },
      async updateSearch () {
        try {
          this.cardsSelected = []
          loader({ active: true })
          this.params = this.searchParams
          this.params.page = this.page
          objSwal.info.title = ""
          objSwal.info.text = "Nenhum resultado encontrado"

          const params = {
            ...this.params,
            cartorio_id: this.$store.state.auth.cartorio_id
          }

          if (!!this.orderBy) {
            Object.assign(params, { orderby: this.orderBy })
          }

          let result = { data: [] }

          if (params.flag_somente_rascunhos === true) {
            if ((params.orderBy != "NOME" && params.orderBy != null) || !this.orderBy) {
              Object.assign(params, { orderby: 'RECENTES' })
            }

            const { data } = await BuscaService.searchRascunhoREI(params)

            if (data.docs) {
              result.data = data.docs.map((item) => transformSearchedRascunho(item))
            }

            result.page = data.page
            result.total = data.total
            result.perPage = data.limit
            result.lastPage = data.pages
          } else {
            const { data } = await BuscaService.searchREI(params)
            result = data
          }

          if (result) {
            if (!result.data.length) {
              this.result = null
              this.page = 1
              this.lastPage = 1
              return Swal.fire(objSwal.info)
            }

            this.result.data = result.data.map(item => {
              item.check = false
              return item
            })

            // TODO: Remover, a ordenação está sendo feita no back-end
            // this.updateOrder(this.orderBy)
            this.cardsSelected = result.data.filter(item => {
              if (item.check) return item
            })

            this.page = result.page
            this.lastPage = result.lastPage
            this.items = result.data || []
          }
        } finally {
          loader({ active: false })
        }
      },
      clearSearch () {
        this.result = null
        this.page = 1
        this.items = []
      },
      nextPage () {
        if (this.page !== this.lastPage) this.page++
        this.updateSearch()
      },
      previousPage () {
        if (this.page !== 1) this.page--
        this.updateSearch()
      },
      setPage (page) {
        this.page = page
        this.updateSearch()
      },
      selectCard (value) {
        let indResult = this.items.indexOf(value)

        if (!this.cardsSelected.includes(value)) {
          this.cardsSelected.push(value)
          this.items[indResult].check = true
        } else {
          let ind = this.cardsSelected.indexOf(value)
          this.cardsSelected.splice(ind, 1)
          this.items[indResult].check = false
        }
      },
      selectAllCards (isAllSelected) {

        this.items = this.items.map(item => {
          item.check = isAllSelected
          return item
        })

        this.items = order(
          this.result.data,
          this.orderBy === null
            ? "registro_id"
            : compType(
              this.searchParams.tipo_livro,
              "nascimento.nome_registrado",
              "casamento.nome_registrado_1",
              "obito.nome_registrado"
            )
        )
        this.cardsSelected = this.items.filter(item => {
          if (item.check) return item
        })
      },
      excludeAll () {
        this.cardsSelected = []
        this.updateSearch()
      },

      showModal (tipo) {
        const actions = {
          nascimento: () => {
            this.$refs["modal-nascimento"].show()
          },
          casamento: () => {
            this.$refs["modal-casamento"].show()
          },
          preRegistro: () => {
            this.$refs["modal-pre-registro"].show()
          },
          obito: () => {
            this.$refs["modal-obito"].show()
          },
        }

        try {
          actions[tipo]()
        } catch (e) {
          console.error('function referente ao tipo não criado em "actions"', '-', e)
        }
      }
    }
  }
</script>

<style lang="scss">
  @import "../../scss/_utilities/_exports";

  #dashboardSofiaRei{
    top: -30px;
  }

  .radioBox {
    border: pxToRem(1) solid $color-gray-light;
    max-width: pxToRem(100);
    min-height: pxToRem(80);
    transition: background-color 0.15s linear, border-color 0.15s linear;
    width: 33%;
    cursor: pointer;

    &_input {
      height: 0;
      opacity: 0;
      width: 0;
    }

    &_icon {
      fill: $color-gray-light;
    }

    &_title {
      color: $color-gray-light;
      font-size: pxToRem(14);
      font-weight: 500;
      transition: color 0.15s linear;
    }

    &.active,
    &:hover {
      background-color: $color-logo;
      border-color: $color-logo;

      .radioBox_icon {
        fill: $color-white;
      }

      .radioBox_title {
        color: $color-white;
      }
    }
  }

  .boxConditions {
    border: pxToRem(4) solid $color-logo;
  }
</style>
